function logger(reducer) {
    return (prevState, action) => {
        let nextState = null;
        const debug = false;
        if (debug) {
            console.group(action.type);
            console.log('Prev State', prevState);
            console.log('Action', action);

            nextState = reducer(prevState, action);

            console.log('Next State', nextState);
            console.groupEnd();
        } else {
            nextState = reducer(prevState, action);
        }

        return nextState;
    };
}

export default logger;
